import { OlxAvailablePackage } from '../../../../../modules/crm/power-olx-v2/interfaces/power-olx-v2.interface';

export interface BuyOlxPackagesPayload {
  channel_id: string;
  planner_id?: string;
  selected_package?: OlxAvailablePackage;
}

export enum AvailablePackageType {
  BASE = 'base',
  PREMIUM = 'premium',
  MEGA = 'mega',
}

export type NormalizedAvailablePackages = Record<AvailablePackageType, OlxAvailablePackage[]>;

export const AVAILABLE_PACKAGE_TYPES: AvailablePackageType[] = [
  AvailablePackageType.BASE,
  AvailablePackageType.PREMIUM,
  AvailablePackageType.MEGA,
];

export const PACKAGE_FEATURE_KEYS: Record<AvailablePackageType, string[]> = {
  base: [
    'olx.features.business_page',
    'olx.features.valid_30_days',
    'olx.features.stats_60_days',
  ],
  premium: [
    'olx.features.raise_each_advert_3x',
    'olx.features.custom_listing_design',
    'olx.features.updated_business_page',
    'olx.features.valid_30_days',
  ],
  mega: [
    'olx.features.raise_each_advert_3x',
    'olx.features.custom_listing_design',
    'olx.features.updated_business_page',
    'olx.features.valid_30_days',
    'olx.features.stats_90_days',
  ],
};
